import React from "react";

const WeekDayRenderer: React.FC<{ element: React.ThHTMLAttributes<HTMLTableCellElement> }> = ({ element }) => {
  return (
    <th
      aria-label="Sunday"
      className="rdp-weekday text-[#BEBEBE]"
      scope="col"
    >
      {element["aria-label"]?.substring(0, 1)}
    </th>
  );
};

export default WeekDayRenderer;
